import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/Backups/Get`, payload),
    Update: (payload) => Repository.post(`/api/Backups/Update`, payload),
}
